import Vue from 'vue'

const state = {
  NavCon: [],
  LoadingMy: false,
  clientHeight: 600,
  OrderList: {
    orders:[],
    pageNum:0,
    pageSize:0,
    recode:'',
    totalElements:0,
    totalPage:0
  },
  orderSoso: {
    orderKeyword:'', // 订单信息
    bargainerKeyword:'', // 卖家信息
    status:'', //  订单状态，10：待发货，20：待收货，30：已完成，40：已关闭
    startDate: '', //     下单开始时间，格式yyyy-mm-dd
    endDate:'', //     下单结束时间，格式yyyy-mm-dd
    page: 1, //    页码，0开始，默认0
    size: 10, //  每页数量，默认10
  },
  OrderDetail: {
    order: {},
    recode:''
  },
  JifenList: {
    datalist:[],
    pageNum:0,
    pageSize:0,
    recode:'',
    totalElements:0,
    totalPages:0
  },
  JifenDetail: {
    datalist: [],
    recode:'',
    totalPage: 0
  },
  orderState: {  },
  jifenSoso: {
    keyword:'', // 搜索关键字
    integralType:'', // 积分类型
    startDate: '', // 2019-05-21 11:16:35
    endDate: '', // 2019-05-21 11:16:35
    minPoint: '', // 最小积分
    maxPoint:'', // 最大积分
    page: 1, //    页码，1开始，默认1
    size: 10, //  每页数量，默认10
  },
}

const getters = {
  NavCon: state => state.NavCon,
  OrderList: state => state.OrderList.orders,
  totalPages: state => state.OrderList.totalPage,
  OrderDetail: state => state.OrderDetail.order,
  JifenList: state => state.JifenList.datalist,
  JifenDetail: state => state.JifenDetail,
  orderState: state => state.orderState,
  LoadingMy: state => state.LoadingMy,
  jifenPages: state => state.JifenDetail.totalPage,
  clientHeight: state => state.clientHeight
}

const mutations = {
  SET_HEIGHT(state, m) {
    state.clientHeight = m
  },
  JIFEN_SOSO_KEY(state, m) {
    state.jifenSoso.keyword = m
  },
  JIFEN_SOSO_INT(state, m) {
    state.jifenSoso.integralType = m
  },
  JIFEN_SOSO_POINTSA(state, m) {
    state.jifenSoso.minPoint = m
  },
  JIFEN_SOSO_POINTSB(state, m) {
    state.jifenSoso.maxPoint = m
  },
  JIFEN_SOSO_DATE(state, m) {
    state.jifenSoso.startDate = m[0]
    state.jifenSoso.endDate = m[1]
  },
  JIFEN_SOSO_PAGE(state, m) {
    state.jifenSoso.page = m.page
    if (m.size) state.jifenSoso.size = m.size
  },
  JIFEN_SOSO_PAGE_ONE(state) {
    state.JifenDetail.totalpage = 0
  },


  ORDER_SOSO_KEY(state, m) {
    state.orderSoso.orderKeyword = m
  },
  ORDER_SOSO_BAR(state, m) {
    state.orderSoso.bargainerKeyword = m
  },
  ORDER_SOSO_STATUS(state, m) {
    state.orderSoso.status = m
  },
  ORDER_SOSO_PAGE(state, m) {
    state.orderSoso.page = m.page
    if (m.size) state.orderSoso.size = m.size
  },
  ORDER_SOSO_DATE(state, m) {
    state.orderSoso.startDate = m[0]
    state.orderSoso.endDate = m[1]
  },
  ORDER_SOSO_PAGE_ONE(state) {
    state.OrderList.totalPage = 0
  },
  NAVCON(state, m) {
    state.NavCon = m
  },
  LOADING_MY(state, m) {
    state.LoadingMy = m
  },
  ADDNAV(state, m) {
    let v = state.NavCon.length > 0 && state.NavCon.find((item) => m.tig == item.tig)
    if (!v) {
      state.NavCon.push(m)
    } else if (v) {
      JSON.parse(JSON.stringify(state.NavCon)).forEach((item, idx) => {
        if (m.tig == item.tig) {
          state.NavCon.splice(idx, 1, Object.assign({}, m))
        }
      })
    }
  },
  DELNAV(state, m) {
    state.NavCon.length > 0 && state.NavCon.forEach((item, idx) => { if (m == item.tig) state.NavCon.splice(idx, 1) })
  },
  GETORDERLIST(state, m) {
    state.OrderList = m
  },
  GETORDERDETAIL(state, m) {
    state.OrderDetail = m
  },
  JIFENLIST(state, m) {
    state.JifenList = m
  },
  JIFENDETAIL(state, m) {
    state.JifenDetail = m
  },
  ORDERSTATE(state, m) {
    state.orderState = m
  }
}

const actions = {
  NAVCON({ commit }, m) {
    commit('NAVCON', m)
  },
  ADDNAV({ commit }, m) {
    commit('ADDNAV', m)
  },
  DELNAV({ commit }, m) {
    commit('DELNAV', m)
  },
  GETORDERLIST({ commit, state }) {
    // 订单列表
    commit("LOADING_MY", true)
    Vue.http.get(Vue.conf.Api.orders,{params: state.orderSoso}).then((res)=>{
      commit("LOADING_MY", false)
      if (res.data.recode == 200) commit('GETORDERLIST', res.data)
    })
  },

  GETORDERDETAIL({ commit }, id) {
    // 订单详细
    commit("LOADING_MY", true)
    Vue.http.get(Vue.conf.Api.orderDetail + id).then((res)=>{
      commit("LOADING_MY", false)
      if (res.data.recode == 200) commit('GETORDERDETAIL', res.data)
    })
  },
  
  JIFENLIST({ commit }) {
    // 积分列表
    commit("LOADING_MY", true)
    Vue.http.get(Vue.conf.Api.pointsList,{params:{}}).then((res)=>{
      commit("LOADING_MY", false)
      if (res.data.recode == 200) commit('JIFENLIST', res.data)
    })
  },

  JIFENDETAIL({ commit, state }, id) {
    // 积分详细
    commit("LOADING_MY", true)
    Vue.http({
      method: `GET`,
      url: Vue.conf.Api.pointDetail + id,
      params: state.jifenSoso
    }).then((res)=>{
      commit("LOADING_MY", false)
      if (res.data.recode == 200) commit('JIFENDETAIL', res.data)
    })
  },

  ORDERSTATE({ commit }) {
    // 欢迎页
    commit("LOADING_MY", true)
    Vue.http.get(Vue.conf.Api.orderState).then((res)=>{
      commit("LOADING_MY", false)
      if (res.data.recode == 200) commit('ORDERSTATE', res.data)
    })
  },

  BATCH_ADD({ commit },o) {
    // 再次兑换
    return new Promise((resolve) => {
      Vue.http({
        method: `POST`,
        headers: {'Content-Type': 'application/json'},
        url: Vue.conf.Api.batchAdd,
        data: o
      }).then(function (res) {
        resolve(res)
      })
    })
  },

  ORDER_OK ({ commit },id) {
    // 确认收货
    return new Promise((resolve) => {
      Vue.http.patch(Vue.conf.Api.apis + `/client/v1/orders/${id}`).then((res)=>{
        resolve(res)
      })
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
